export default "__VITE_ASSET__BiDmmLVb__"